/**
 * Placement Controls Component
 *
 * Provides controls for piece placement including:
 * - Rotation button
 * - Current rotation display
 * - Disabled state when placement locked
 */

import { COPY } from '../copy';

export default function PlacementControls({
  currentRotation = 0,
  onRotate,
  isLocked = false,
}) {
  const rotationDegrees = currentRotation * 90;

  return (
    <div className="flex items-center gap-4 p-4 bg-dark-purple border-2 border-neon-cyan/50 rounded-lg">
      <button
        data-testid="rotate-button"
        onClick={onRotate}
        disabled={isLocked}
        className="px-6 py-3 bg-neon-cyan text-dark-navy border-2 border-white/70 font-semibold rounded-lg hover:bg-neon-pink hover:border-white/70 hover:text-white disabled:bg-dark-purple/50 disabled:border-gray-600 disabled:text-gray-500 disabled:cursor-not-allowed transition-all shadow-glow-cyan"
        aria-label="Rotate piece clockwise"
      >
        {COPY.placement.buttons.rotate}
      </button>
      <div
        data-testid="rotation-display"
        className="text-lg font-semibold text-neon-cyan"
      >
        {COPY.placement.rotation.degrees(rotationDegrees)}
      </div>
    </div>
  );
}
